(() => {
  window.__kuddyPdpCartHandler = true;

  const root = document.querySelector('[data-main-product]');
  if (!root) return;

  const readJson = (selector, fallback = {}) => {
    try {
      return JSON.parse(document.querySelector(selector)?.textContent || '{}');
    } catch (_error) {
      return fallback;
    }
  };

  const config = readJson('[data-kuddy-product-config]');
  const productId = config.productId;
  const productSignal = config.productSignal || '';
  const recommendationContext = config.recommendationContext || {};
  const kuddyProductAnalytics = readJson('[data-kuddy-product-analytics]');
  const productAnalyticsDefaults = {
    item_name: kuddyProductAnalytics.item_name || '',
    name: kuddyProductAnalytics.name || kuddyProductAnalytics.item_name || '',
    item_brand: kuddyProductAnalytics.item_brand || '',
    brand: kuddyProductAnalytics.brand || kuddyProductAnalytics.item_brand || '',
    item_category: kuddyProductAnalytics.item_category || '',
    category: kuddyProductAnalytics.category || kuddyProductAnalytics.item_category || '',
    price: kuddyProductAnalytics.price || 0,
  };


        const togglePanel = (button, panel, openText, closeText) => {
      if (!button || !panel) return;
      const opening = panel.hasAttribute('hidden');
      if (opening) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
      button.setAttribute('aria-expanded', String(opening));
      button.textContent = opening ? closeText : openText;
      button.classList.toggle('is-open', opening);
      if (opening) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        panel.querySelector('input:not([type="hidden"]), textarea, select')?.focus({ preventScroll: true });
      }
    };

    root.querySelector('[data-review-toggle]')?.addEventListener('click', () => {
      togglePanel(root.querySelector('[data-review-toggle]'), root.querySelector('[data-review-panel]'), 'Write a review', 'Close');
    });

    root.querySelector('[data-qa-toggle]')?.addEventListener('click', () => {
      togglePanel(root.querySelector('[data-qa-toggle]'), root.querySelector('[data-qa-panel]'), 'Ask a question', 'Close');
    });

    const variants = JSON.parse(document.querySelector('[data-product-variants]')?.textContent || '[]');
    const form = root.querySelector('[data-product-form]');
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const atc = root.querySelector('[data-add-to-cart]');
    const atcLabel = root.querySelector('[data-atc-label]');
    const stickySubmit = root.querySelector('[data-sticky-submit]');
    const status = root.querySelector('[data-product-status]');
    const sku = root.querySelector('[data-product-sku]');
    const subscribeSave = root.querySelector('[data-subscribe-save]');
    const subscribeCadence = root.querySelector('[data-subscribe-cadence]');
                const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format((Number(cents) || 0) / 100);
      } catch (_error) {
        return '₦' + ((Number(cents) || 0) / 100).toLocaleString('en-NG');
      }
    };

    const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);

        const normalizeTrackItem = (variant, quantity = 1) => {
      const selectedVariant = variant || {};
      const selectedVariantId = selectedVariant.id || kuddyProductAnalytics.item_id || productId;
      return {
        id: String(selectedVariantId),
        item_id: String(selectedVariantId),
        item_name: String(selectedVariant.title || selectedVariant.name || kuddyProductAnalytics.item_name || ''),
        item_brand: String(selectedVariant.vendor || kuddyProductAnalytics.item_brand || ''),
        item_category: String(selectedVariant.product_type || selectedVariant.type || kuddyProductAnalytics.item_category || ''),
        item_variant: String(selectedVariant.id || ''),
        price: Number(selectedVariant.price || kuddyProductAnalytics.price || 0),
        quantity: Number(quantity || 1),
      };
    };

    const trackAddToCart = (items, detail = {}) => {
      if (typeof window?.kuddyAnalytics?.trackAddToCart !== 'function') return;
      if (!Array.isArray(items) || !items.length) return;
      const payload = items.filter((item) => item && item.item_id);
      if (!payload.length) return;
      window.kuddyAnalytics.trackAddToCart(payload, detail);
    };

    const selectedOptions = () => Array.from(root.querySelectorAll('[data-option-position]')).map((fieldset) => {
      return fieldset.querySelector('[data-option-input]:checked')?.value;
    });

    const findVariant = () => {
      const options = selectedOptions();
      return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
    };

    const selectedProductVariant = () => findVariant() || variants?.[0] || {};

    const currentSellingPlanIds = () => {
      const option = select?.selectedOptions?.[0];
      return String(option?.dataset?.sellingPlanIds || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
    };

    const setSellingPlan = (planId) => {
      if (!form) return;
      let input = form.querySelector('input[name="selling_plan"]');
      if (planId) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        input.value = planId;
      } else if (input) {
        input.remove();
      }
    };

    const syncSubscribeSave = () => {
      if (!subscribeSave) return;
      const validIds = currentSellingPlanIds();
      const canSubscribe = validIds.length > 0;
      subscribeSave.hidden = !canSubscribe;
      if (!canSubscribe) {
        setSellingPlan('');
        subscribeCadence?.setAttribute('hidden', '');
        const oneTime = subscribeSave.querySelector('[data-purchase-type][value="onetime"]');
        if (oneTime) oneTime.checked = true;
        return;
      }

      const selectedType = subscribeSave.querySelector('[data-purchase-type]:checked')?.value || 'onetime';
      subscribeSave.querySelectorAll('[data-selling-plan-option]').forEach((radio) => {
        const valid = validIds.includes(String(radio.value));
        radio.disabled = !valid;
        radio.closest('label')?.classList.toggle('is-disabled', !valid);
        if (!valid && radio.checked) radio.checked = false;
      });
      if (selectedType === 'subscribe') {
        let checked = subscribeSave.querySelector('[data-selling-plan-option]:checked:not(:disabled)');
        if (!checked) {
          checked = subscribeSave.querySelector('[data-selling-plan-option]:not(:disabled)');
          if (checked) checked.checked = true;
        }
        subscribeCadence?.removeAttribute('hidden');
        setSellingPlan(checked?.value || '');
      } else {
        subscribeCadence?.setAttribute('hidden', '');
        setSellingPlan('');
      }
    };

    const setGalleryMedia = (mediaId) => {
      if (!mediaId) return;
      root.querySelectorAll('[data-media-id]').forEach((frame) => {
        const active = frame.dataset.mediaId === String(mediaId);
        frame.hidden = !active;
        frame.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaThumb === String(mediaId));
      });
    };

    const stockReminder = root.querySelector('[data-kuddy-stock-reminder]');
    const stockVariantInput = root.querySelector('[data-stock-reminder-variant]');
    const stockVariantTitleInput = root.querySelector('[data-stock-reminder-variant-title]');
    const stockLine = root.querySelector('[data-kp-stock-line]');
    const fulfillmentPickup = root.querySelector('[data-fulfillment-pickup]');
    const fulfillmentPickupCard = root.querySelector('[data-fulfillment-pickup-card]');
    const variantPickupMap = JSON.parse(document.querySelector('[data-variant-pickup]')?.textContent || '{}');
    const fulfillmentConfig = JSON.parse(document.querySelector('[data-fulfillment-config]')?.textContent || '{}');
    const pickupFallbackText = fulfillmentConfig.pickupFallbackText || 'Ready in 2 hrs';
    const fulfillmentShip = root.querySelector('[data-fulfillment-ship]');
    const fulfillmentSameDay = root.querySelector('[data-fulfillment-same-day]');
    const rewardLine = root.querySelector('[data-kuddy-reward-line]');

    const estimatedRewardPoints = (priceCents) => {
      const rate = Number(fulfillmentConfig.rewardsPointsRate || 1);
      const cents = Number(priceCents || 0);
      const raw = Math.floor((cents * rate) / 10000);
      return raw < 1 && cents > 0 ? 1 : Math.max(0, raw);
    };

    const formatRewardLine = (points) => {
      if (!fulfillmentConfig.rewardsEnabled || !rewardLine) return;
      const count = Math.max(0, Number(points) || 0);
      const label = count === 1 ? 'Glow point' : 'Glow points';
      if (count > 0 && fulfillmentConfig.customerLoggedIn) {
        rewardLine.innerHTML = `You&rsquo;ll earn about ${count} ${label} on this order`;
        return;
      }
      if (count > 0) {
        const url = fulfillmentConfig.rewardsPromptUrl || '/account/login';
        rewardLine.innerHTML = `<a href="${encodeURI(url)}">Sign in</a> to earn about ${count} ${label} on this order`;
        return;
      }
      rewardLine.textContent = fulfillmentConfig.customerLoggedIn
        ? "You'll earn Glow points on this order"
        : 'Sign in to earn points on this order';
    };

    async function hydrateLiveFulfillment(variant) {
      if (!fulfillmentConfig.useLiveShipping || !fulfillmentShip) return;
      const params = new URLSearchParams();
      const province = fulfillmentConfig.customerProvince || localStorage.getItem('kuddy:province') || '';
      const city = fulfillmentConfig.customerCity || localStorage.getItem('kuddy:city') || '';
      if (province) params.set('province', province);
      if (city) params.set('city', city);
      const subtotalNaira = Math.round(Number(variant?.price || 0) / 100);
      if (subtotalNaira > 0) params.set('subtotal_naira', String(subtotalNaira));
      try {
        const response = await fetch(`/apps/kuddy-dev/fulfillment?${params.toString()}`, { headers: { Accept: 'application/json' } });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'Could not load fulfillment.');
        if (payload.estimate?.shipLabel) fulfillmentShip.textContent = payload.estimate.shipLabel;
        if (fulfillmentSameDay && payload.estimate?.sameDayAreas) fulfillmentSameDay.textContent = payload.estimate.sameDayAreas;
      } catch (_error) {
        fulfillmentShip.textContent = fulfillmentShip.dataset.freeShipDisplay || fulfillmentConfig.freeShipDisplay || fulfillmentShip.textContent;
        if (fulfillmentSameDay?.dataset.sameDayFallback) fulfillmentSameDay.textContent = fulfillmentSameDay.dataset.sameDayFallback;
      }
    }

    const updateVariant = (variant) => {
      if (!variant || !select) return;
      select.value = variant.id;
      if (price) price.innerHTML = `<span>${formatMoney(variant.price)}</span>${variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}`;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      const currentRoutineInput = root.querySelector('[data-routine-current]');
      const currentRoutinePrice = root.querySelector('[data-routine-current-price]');
      if (currentRoutineInput) currentRoutineInput.value = variant.id;
      if (currentRoutinePrice) currentRoutinePrice.textContent = formatMoney(variant.price);
      if (sku) sku.textContent = variant.sku ? `SKU ${variant.sku}` : '';
      if (atc) atc.disabled = !variant.available;
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      const label = variant.available ? 'Add to Cart' : 'Sold Out';
      if (atcLabel) atcLabel.textContent = label;
      if (stickySubmit) stickySubmit.textContent = label;
      if (stockReminder) stockReminder.hidden = variant.available;
      if (stockLine) stockLine.hidden = !variant.available;
      if (stockVariantInput) stockVariantInput.value = variant.id;
      if (stockVariantTitleInput) stockVariantTitleInput.value = variant.title || '';
      const pickupEntry = variantPickupMap[String(variant.id)];
      if (fulfillmentPickup) {
        fulfillmentPickup.textContent = pickupEntry?.text || pickupFallbackText;
        fulfillmentPickup.classList.toggle('is-fallback', !pickupEntry?.live);
      }
      if (fulfillmentPickupCard) {
        fulfillmentPickupCard.dataset.pickupLive = pickupEntry?.live ? 'true' : 'false';
      }
      void hydrateLiveFulfillment(variant);
      formatRewardLine(estimatedRewardPoints(variant?.price));
      if (variant.featured_media) setGalleryMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      syncSubscribeSave();
      const primaryFbtInput = fbtSection?.querySelector('[data-fbt-variant]');
      if (primaryFbtInput) {
        primaryFbtInput.value = variant.id;
        primaryFbtInput.dataset.fbtPrice = String(toCents(variant.price));
      }
      updateFbtTotals();
    };

    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-option-input]')) return;
      const fieldset = event.target.closest('[data-option-position]');
      const label = root.querySelector(`[data-option-label="${fieldset.dataset.optionPosition}"]`);
      if (label) label.textContent = event.target.value;
      updateVariant(findVariant());
    });

    root.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-media-thumb]');
      if (thumb) setGalleryMedia(thumb.dataset.mediaThumb);
      if (event.target.matches('[data-qty-minus], [data-qty-plus]')) {
        const input = root.querySelector('[data-qty-input]');
        const next = Math.max(1, Number(input.value || 1) + (event.target.matches('[data-qty-plus]') ? 1 : -1));
        input.value = next;
      }
      if (event.target.matches('[data-sticky-submit]')) {
        atc?.click();
      }
    });

    subscribeSave?.addEventListener('change', (event) => {
      if (!event.target.matches('[data-purchase-type], [data-selling-plan-option]')) return;
      syncSubscribeSave();
    });

    const refreshAndOpenCartDrawer = async (sections) => {
      if (window.KuddyDeferredUi?.openAfterAdd) {
        return window.KuddyDeferredUi.openAfterAdd(sections);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { sections: sections || null } }));
      document.dispatchEvent(new CustomEvent('cart:open', { detail: { sections: sections || null } }));
      document.querySelector('[data-target="CartDrawer"][data-js-toggle="CartDrawer"]')?.click();
    };

    let addInFlight = false;
    const appendCartDrawerSection = (body) => {
      const cartDrawerSection = document.querySelector('#CartDrawer')?.dataset.sectionId;
      if (!cartDrawerSection) return body;

      if (body instanceof FormData) {
        body.append('sections', cartDrawerSection);
        body.append('sections_url', window.location.pathname);
        return body;
      }

      return {
        ...body,
        sections: cartDrawerSection,
        sections_url: window.location.pathname
      };
    };

    const submitProductForm = async (event) => {
      event.preventDefault();
      if (addInFlight) return;
      addInFlight = true;
      status.textContent = '';
      const body = appendCartDrawerSection(new FormData(form));
      const selected = selectedProductVariant();
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Could not add item');
        const payload = await response.json().catch(() => ({}));
        const cartItem = Array.isArray(payload?.items)
          ? payload.items.find((item) => String(item.variant_id || item.variantId || '') === String(selected?.id || form?.querySelector('[name="id"]')?.value || ''))
          : null;
        const qty = Number(form?.querySelector('[name="quantity"]')?.value || 1);
        const trackableVariant = selected || {
          ...productAnalyticsDefaults,
          id: cartItem?.variant_id || cartItem?.variantId || form?.querySelector('[name="id"]')?.value,
          title: selected?.title || kuddyProductAnalytics.item_name || productAnalyticsDefaults.item_name,
          vendor: selected?.vendor || kuddyProductAnalytics.item_brand || productAnalyticsDefaults.item_brand,
          brand: selected?.vendor || kuddyProductAnalytics.item_brand || productAnalyticsDefaults.item_brand,
          product_type: selected?.type || kuddyProductAnalytics.item_category || productAnalyticsDefaults.item_category,
          category: selected?.type || kuddyProductAnalytics.item_category || productAnalyticsDefaults.item_category,
          item_name: selected?.title || kuddyProductAnalytics.item_name || productAnalyticsDefaults.item_name,
          name: selected?.title || kuddyProductAnalytics.item_name || productAnalyticsDefaults.item_name,
          price: cartItem?.price || selected?.price || productAnalyticsDefaults.price || 0,
        };
        trackAddToCart([normalizeTrackItem(trackableVariant, qty)], {
          source: 'product_page'
        });
        status.textContent = 'Added to cart.';
        await refreshAndOpenCartDrawer(payload.sections);
      } catch (error) {
        status.textContent = error.message || 'Could not add item.';
      } finally {
        addInFlight = false;
      }
    };

    document.addEventListener('submit', (event) => {
      if (event.target === form) submitProductForm(event);
    }, true);
    document.addEventListener('click', (event) => {
      const clickedAtc = event.target.closest('[data-add-to-cart]');
      if (!clickedAtc || !root.contains(clickedAtc) || clickedAtc.disabled) return;
      submitProductForm(event);
    }, true);

    syncSubscribeSave();

    root.querySelector('[data-routine-add]')?.addEventListener('click', async () => {
      const routineStatus = root.querySelector('[data-routine-status]');
      const items = Array.from(root.querySelectorAll('[data-routine-variant]:checked')).map((input) => ({ id: Number(input.value), quantity: 1 }));
      if (!items.length) return;
      const variants = items
        .map((item) => normalizeTrackItem({
          id: item.id,
          ...productAnalyticsDefaults
        }, item.quantity || 1))
        .filter((item) => item.item_id);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(appendCartDrawerSection({ items }))
        });
        if (!response.ok) throw new Error('Could not add routine');
        const payload = await response.json().catch(() => ({}));
        trackAddToCart(variants, { source: 'routine' });
        routineStatus.textContent = 'Routine added to cart.';
        await refreshAndOpenCartDrawer(payload.sections);
      } catch (error) {
        routineStatus.textContent = error.message || 'Could not add routine.';
      }
    });

    root.querySelector('[data-fbt-add]')?.addEventListener('click', async () => {
      const fbtStatus = root.querySelector('[data-fbt-status]');
      const items = Array.from(root.querySelectorAll('[data-fbt-variant]:checked')).map((input) => ({ id: Number(input.value), quantity: 1 }));
      if (!items.length) return;
      const trackedFbt = items
        .map((item) => normalizeTrackItem({
          id: item.id,
          ...productAnalyticsDefaults
        }, item.quantity || 1))
        .filter((item) => item.item_id);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(appendCartDrawerSection({ items }))
        });
        if (!response.ok) throw new Error('Could not add bundle');
        const payload = await response.json().catch(() => ({}));
        trackAddToCart(trackedFbt, { source: 'fbt' });
        if (fbtStatus) fbtStatus.textContent = 'Bundle added to cart.';
        await refreshAndOpenCartDrawer(payload.sections);
      } catch (error) {
        if (fbtStatus) fbtStatus.textContent = error.message || 'Could not add bundle.';
      }
    });

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-like-add]');
      if (!button) return;
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(appendCartDrawerSection({ id: Number(button.dataset.variantId), quantity: 1 }))
        });
        if (!response.ok) throw new Error('Could not add');
        const payload = await response.json().catch(() => ({}));
        button.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { sections: payload.sections || null } }));
      } catch (_error) {
        button.textContent = 'Try again';
        button.disabled = false;
      }
    });

    root.querySelector('[data-kuddy-stock-reminder-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const stockForm = event.target;
      const stockStatus = stockForm.querySelector('[data-kuddy-stock-reminder-status]');
      stockStatus.textContent = 'Saving your reminder...';
      stockStatus.classList.remove('is-success');
      try {
        const response = await fetch(stockForm.action, {
          method: 'POST',
          body: new FormData(stockForm),
          headers: { Accept: 'application/json' }
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'We could not save your reminder. Please try again.');
        stockStatus.textContent = payload.message || 'You are on the list. We will email you when this item is back.';
        stockStatus.classList.add('is-success');
      } catch (error) {
        stockStatus.textContent = error.message || 'We could not save your reminder. Please try again.';
        stockStatus.classList.remove('is-success');
      }
    });

    root.querySelector('[data-kuddy-qa-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const qaForm = event.target;
      const qaStatus = qaForm.querySelector('[data-kuddy-qa-status]');
      qaStatus.textContent = 'Sending question...';
      try {
        const response = await fetch(qaForm.action, {
          method: 'POST',
          body: new FormData(qaForm),
          headers: { Accept: 'application/json' }
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'We couldn\'t send your question. Please try again or contact us.');
        qaStatus.textContent = payload.message || 'Question received. We will answer it after review.';
        qaStatus.classList.add('is-success');
        qaForm.reset();
      } catch (error) {
        qaStatus.textContent = error.message || 'We couldn\'t send your question. Please try again or contact us.';
        qaStatus.classList.remove('is-success');
      }
    });

    root.querySelector('[data-kuddy-review-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const reviewForm = event.target;
      const reviewStatus = reviewForm.querySelector('[data-kuddy-review-status]');
      reviewStatus.textContent = 'Sending review...';
      try {
        const response = await fetch(reviewForm.action, {
          method: 'POST',
          body: new FormData(reviewForm),
          headers: { Accept: 'application/json' }
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'We couldn\'t submit your review. Please try again.');
        reviewStatus.textContent = payload.message || 'Review received. Thank you for helping the Kuddy community.';
        reviewStatus.classList.add('is-success');
        reviewForm.reset();
        if (payload.status === 'approved') {
          await hydrateApprovedReviews();
        }
      } catch (error) {
        reviewStatus.textContent = error.message || 'We couldn\'t submit your review. Please try again.';
        reviewStatus.classList.remove('is-success');
      }
    });

    const renderStars = (rating) => {
      const value = Math.max(1, Math.min(5, Number(rating) || 5));
      return Array.from({ length: 5 }, (_, index) => `<span class="${index < value ? 'is-filled' : ''}" aria-hidden="true">&#9733;</span>`).join('');
    };

    const formatReviewDate = (value) => {
      const date = new Date(value || '');
      return Number.isNaN(date.getTime()) ? 'Approved' : date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    };

    const reviewsRoot = root.querySelector('[data-kuddy-reviews]');
    const productHandle = reviewsRoot?.dataset.productHandle;

    async function hydrateApprovedReviews() {
      if (!productHandle || !reviewsRoot) return;
      const list = reviewsRoot.querySelector('[data-kuddy-review-list]');
      if (!list) return;
      try {
        const response = await fetch(`/apps/kuddy-dev/products/${encodeURIComponent(productHandle)}/reviews`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        if (!data.ok || !data.reviews?.length) return;

        list.innerHTML = data.reviews.slice(0, 6).map((review) => {
          const meta = [review.verified ? 'Verified buyer' : '', review.skinType, review.location].filter(Boolean).join(' - ');
          const initial = escapeHtml((review.author || 'K').slice(0, 1).toUpperCase());
          return `
            <article class="kp-review-card">
              <div class="kp-review-card__head">
                <span class="kp-review-card__avatar">${initial}</span>
                <div><strong>${escapeHtml(review.author || 'Kuddy customer')}</strong>${meta ? `<small>${escapeHtml(meta)}</small>` : ''}</div>
                <time>${escapeHtml(formatReviewDate(review.createdAt))}</time>
              </div>
              <div class="kp-review-card__stars" aria-label="${Number(review.rating) || 5} out of 5 stars">${renderStars(review.rating)}</div>
              ${review.title ? `<h3>${escapeHtml(review.title)}</h3>` : ''}
              <p>${escapeHtml(review.body)}</p>
              ${review.image ? `<img class="kp-review-card__image" src="${escapeHtml(review.image)}" alt="${escapeHtml(review.title || 'Customer review photo')}" loading="lazy">` : ''}
              <button type="button" class="kp-review-card__help" data-review-helpful="${escapeHtml(review.id)}">Helpful${review.helpful ? ` (${Number(review.helpful)})` : ''}</button>
            </article>
          `;
        }).join('');

        const average = Number(data.average || 0).toFixed(1);
        reviewsRoot.querySelector('[data-kuddy-review-meter-score] strong').textContent = average;
        reviewsRoot.querySelector('[data-kuddy-review-meter-count]').textContent = `${data.count} verified ${data.count === 1 ? 'review' : 'reviews'}`;

        const barsEl = reviewsRoot.querySelector('[data-kuddy-review-meter-bars]');
        if (barsEl && data.distribution?.length) {
          barsEl.innerHTML = data.distribution.map(({ star, percent }) =>
            `<div><span>${star} &#9733;</span><i style="--bar:${percent}%"></i><b>${percent}%</b></div>`
          ).join('');
          barsEl.hidden = false;
        } else if (barsEl) {
          barsEl.hidden = true;
        }

        const score = reviewsRoot.querySelector('[data-kuddy-review-score]');
        if (score) {
          score.setAttribute('aria-label', `${average} out of 5 stars from ${data.count} reviews`);
          score.querySelector('strong').textContent = average;
          score.querySelector('small').textContent = `${data.count} ${data.count === 1 ? 'review' : 'reviews'}`;
        }
      } catch (_error) {
        // Keep the prototype fallback if the Kuddy dev read service is unavailable.
      }
    }

    reviewsRoot?.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-review-helpful]');
      if (!button) return;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = 'Saving...';
      try {
        const response = await fetch(`/apps/kuddy-dev/reviews/${encodeURIComponent(button.dataset.reviewHelpful)}/helpful`, {
          method: 'POST',
          headers: { Accept: 'application/json' }
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'Could not save helpful vote.');
        button.textContent = `Helpful (${Number(payload.helpful) || 1})`;
        button.classList.add('is-voted');
      } catch (_error) {
        button.disabled = false;
        button.textContent = original;
      }
    });

    async function hydrateApprovedQuestions() {
      if (!productHandle) return;
      const qaRoot = root.querySelector('[data-kuddy-qa]');
      const list = qaRoot?.querySelector('[data-kuddy-qa-list]');
      if (!qaRoot || !list) return;
      try {
        const response = await fetch(`/apps/kuddy-dev/products/${encodeURIComponent(productHandle)}/questions`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        if (!data.ok || !data.questions?.length) return;

        list.innerHTML = data.questions.slice(0, 8).map((item) => `
          <article>
            <aside>Asked by<br><strong>${escapeHtml(item.author || 'Kuddy customer')}</strong><span>${escapeHtml(item.topic || 'Product details')}</span></aside>
            <div><h3><span>Q:</span> ${escapeHtml(item.question)}</h3><p><strong>Official answer by Kuddy Beauty Advisor</strong></p><p>${escapeHtml(item.answer)}</p></div>
          </article>
        `).join('');

        const countLabel = `${data.count} ${data.count === 1 ? 'question' : 'questions'} about this product`;
        qaRoot.querySelector('[data-kuddy-qa-count]').textContent = countLabel;
        qaRoot.querySelector('[data-kuddy-qa-showing]').textContent = `Showing ${data.count} of ${data.count}`;
      } catch (_error) {
        // Keep the prototype fallback if the Kuddy dev read service is unavailable.
      }
    }

    hydrateApprovedReviews();
    hydrateApprovedQuestions();

    if (atc && stickySubmit) {
      const stickyBar = root.querySelector('[data-sticky-atc]');
      const updateSticky = () => {
        stickyBar?.classList.toggle('is-visible', atc.getBoundingClientRect().bottom < 0);
      };
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
    }

    const fbtSection = root.querySelector('[data-fbt]');
    const selectedVariant = () => {
      const explicit = variants.find((entry) => String(entry.id) === String(select?.value));
      return explicit || variants?.[0];
    };
    const currentProductKey = String(productId || '');
    const normalizeProductKey = (value) => String(value || '').replace(/^gid:\/\/shopify\/Product\//, '');
    const toCents = (value) => {
      const amount = Number(value);
      return Number.isFinite(amount) ? Math.max(0, Math.round(amount)) : 0;
    };
        const uniqueRecommendationSignals = () => {
      const concerns = Array.isArray(recommendationContext.concerns) ? recommendationContext.concerns : [];
      return Array.from(new Set(
        concerns
          .concat([
            String(recommendationContext.skinType || ''),
            String(recommendationContext.primaryConcern || ''),
            String(recommendationContext.quizType || ''),
            String(recommendationContext.quizResult || ''),
          ])
          .map((value) => String(value || '').toLowerCase().trim())
          .filter(Boolean)
      ));
    };

    const readCartProductIds = async () => {
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return [];
        const cart = await response.json();
        const ids = (cart?.items || [])
          .map((item) => normalizeProductKey(item?.product_id || ''))
          .filter(Boolean)
          .filter((value) => normalizeProductKey(currentProductKey) !== normalizeProductKey(value));
        return Array.from(new Set(ids));
      } catch (_error) {
        return [];
      }
    };

    const hydrateKuddyRecommendations = async (segment, limit = 4) => {
      if (!productId) return { ok: false, items: [], source: 'disabled' };
      const cartIds = await readCartProductIds();
      const query = new URLSearchParams({ product_id: String(productId), limit: String(limit) });
      if (cartIds.length) query.set('cart', cartIds.join(','));
      if (recommendationContext.customerId) query.set('logged_in_customer_id', String(recommendationContext.customerId));
      const concernHints = uniqueRecommendationSignals();
      if (concernHints.length) query.set('concerns', concernHints.join(','));
      if (recommendationContext.skinType) query.set('skin_type', String(recommendationContext.skinType));
      if (recommendationContext.primaryConcern) query.set('primary_concern', String(recommendationContext.primaryConcern));
      if (recommendationContext.quizType) query.set('quiz_type', String(recommendationContext.quizType));
      if (recommendationContext.quizResult) query.set('quiz_result', String(recommendationContext.quizResult));

      const response = await fetch(`/apps/kuddy-dev/recommendations/${segment}?${query.toString()}`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return { ok: false, source: 'http-error', items: [] };
      const payload = await response.json().catch(() => ({}));
      const items = Array.isArray(payload?.items) ? payload.items.filter((item) => item) : [];
      return {
        ...payload,
        ok: Boolean(payload?.ok),
        items,
      };
    };

    const updateFbtTotals = () => {
      if (!fbtSection) return;
      const totalTarget = fbtSection.querySelector('[data-fbt-total]');
      const addTarget = fbtSection.querySelector('[data-fbt-add]');
      const selectedLines = Array.from(fbtSection.querySelectorAll('[data-fbt-variant]:checked'));
      const total = selectedLines.reduce((sum, input) => sum + toCents(input?.dataset?.fbtPrice), 0);
      const count = selectedLines.length;
      if (totalTarget) totalTarget.textContent = `Subtotal: ${formatMoney(total)}`;
      if (addTarget) addTarget.textContent = count > 1 ? `Add ${count} to Bag` : 'Add to Bag';
    };

    root.addEventListener('change', (event) => {
      if (event.target.closest('[data-fbt] [data-fbt-variant]')) {
        updateFbtTotals();
      }
    });

    const routine = root.querySelector('[data-product-routine][data-routine-source="catalog"]');
    const routineRole = (item) => {
      const signal = `${item.title || ''} ${item.type || ''} ${(item.tags || []).join(' ')}`.toLowerCase();
      if (/primer|prep/.test(signal)) return 'prep';
      if (/lipstick|lip gloss|lip liner|lip pencil|color stick|lip/.test(signal)) return 'lip';
      if (/foundation|concealer|bb|cc|complexion/.test(signal)) return 'complexion';
      if (/setting powder|pressed powder|loose powder|face powder|compact powder|set n|setting spray|fixing spray|finish/.test(signal)) return 'set';
      if (/brush|sponge|puff|tool/.test(signal)) return 'tool';
      if (/cleanser|face wash|soap|shampoo|wash/.test(signal)) return 'cleanse';
      if (/toner|astringent/.test(signal)) return 'tone';
      if (/serum|treatment|mask|peel/.test(signal)) return 'treat';
      if (/moistur|cream|lotion|balm|oil|milk/.test(signal)) return 'moisturize';
      if (/sunscreen|sunblock|spf/.test(signal)) return 'protect';
      if (/conditioner/.test(signal)) return 'condition';
      if (/gel|pomade|edge|styling|curl/.test(signal)) return 'style';
      if (/deodorant|mist|perfume|fragrance|body spray/.test(signal)) return 'freshen';
      return 'related';
    };

    const desiredRoutineRoles = () => {
      if (/lipstick|lip gloss|lip liner|lip pencil|color stick|lip makeup/.test(productSignal)) return ['lip', 'complexion', 'set', 'tool'];
      if (/foundation|concealer|powder|bb|cc|complexion/.test(productSignal)) return ['prep', 'complexion', 'set', 'tool'];
      if (/cleanser|face wash|acne|toner|serum|moistur|sunscreen|skin/.test(productSignal)) return ['cleanse', 'tone', 'treat', 'moisturize', 'protect'];
      if (/shampoo|conditioner|hair|edge|curl|scalp/.test(productSignal)) return ['cleanse', 'condition', 'treat', 'style'];
      if (/fragrance|perfume|mist|deodorant|body/.test(productSignal)) return ['moisturize', 'freshen', 'protect'];
      return ['cleanse', 'treat', 'moisturize', 'protect'];
    };

    const scoreRoutineProduct = (item) => {
      const signal = `${item.title || ''} ${item.type || ''} ${(item.tags || []).join(' ')}`.toLowerCase();
      const role = routineRole(item);
      let score = 0;
      const desired = desiredRoutineRoles();
      const desiredIndex = desired.indexOf(role);
      if (desiredIndex >= 0) score += 180 - desiredIndex * 8;

      if (productSignal.includes('foundation') || productSignal.includes('concealer') || productSignal.includes('powder')) {
        if (signal.includes('setting spray')) score += 120;
        if (signal.includes('setting powder') || signal.includes('set n')) score += 110;
        if (signal.includes('primer')) score += 100;
        if (signal.includes('powder')) score += 80;
        if (signal.includes('brush') || signal.includes('sponge')) score += 70;
        if (signal.includes('concealer')) score += 45;
        if (role === 'complexion' && productSignal.includes('foundation')) score -= 70;
        if (signal.includes('conditioner') || signal.includes('hair')) score -= 80;
        if (signal.includes('serum') && !signal.includes('setting')) score -= 30;
      } else if (/lipstick|lip gloss|lip liner|lip pencil|color stick|lip makeup/.test(productSignal)) {
        if (role === 'lip') score += 130;
        if (signal.includes('lip liner') || signal.includes('lip pencil')) score += 120;
        if (signal.includes('lip gloss') || signal.includes('lipstick') || signal.includes('color stick')) score += 95;
        if (role === 'complexion') score += 45;
        if (role === 'set' || role === 'tool') score += 35;
        if (/serum|toner|cleanser|shampoo|conditioner|hair|lotion|cream/.test(signal) && !/lip/.test(signal)) score -= 120;
      } else if (productSignal.includes('acne') || productSignal.includes('face wash') || productSignal.includes('cleanser')) {
        if (signal.includes('toner')) score += 120;
        if (signal.includes('serum')) score += 105;
        if (signal.includes('moistur')) score += 95;
        if (signal.includes('sunscreen')) score += 90;
        if (signal.includes('mask')) score += 70;
      } else if (productSignal.includes('fragrance') || productSignal.includes('perfume') || productSignal.includes('oud')) {
        if (signal.includes('lotion') || signal.includes('body')) score += 110;
        if (signal.includes('oil') || signal.includes('mist')) score += 90;
        if (signal.includes('deodorant')) score += 70;
      } else if (productSignal.includes('hair') || productSignal.includes('edge') || productSignal.includes('shampoo')) {
        if (signal.includes('conditioner')) score += 120;
        if (signal.includes('oil')) score += 90;
        if (signal.includes('growth') || signal.includes('gel')) score += 80;
        if (signal.includes('brush')) score += 60;
      }

      return score;
    };

    const routineImage = (item) => item.featured_image || item.images?.[0] || item.media?.[0]?.preview_image?.src || '';
    const routineVariant = (item) => (item.variants || []).find((variant) => variant.available) || item.variants?.[0];

    const renderRoutineCard = (item, badge) => {
      const variant = routineVariant(item);
      if (!variant) return '';
      const image = routineImage(item);
      return `
        <label class="kp-routine__item">
          <input type="checkbox" checked value="${variant.id}" data-routine-variant>
          <span class="kp-routine__media">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
          </span>
          <span class="kp-routine__copy">
            <span class="kp-routine__badge">${escapeHtml(badge)}</span>
            <strong>${escapeHtml(item.title)}</strong>
            <span>${formatMoney(variant.price)}</span>
          </span>
        </label>
      `;
    };

    const updateFbtFromPayload = async () => {
      if (!fbtSection) return false;
      const payload = await hydrateKuddyRecommendations('fbt', 5);
      if (!payload?.ok || !Array.isArray(payload.items) || !payload.items.length) {
        // Fall back silently to the server-rendered catalog picks — no data-source
        // status text for shoppers (that slot is for add-to-cart feedback).
        return false;
      }
      const candidates = payload.items;

      const container = fbtSection.querySelector('.kp-fbt__items');
      if (!container) return false;
      const current = container.querySelector('.kp-fbt__item');
      if (!current) return false;

      const currentVariant = selectedVariant();
      const currentInput = container.querySelector('[data-fbt-variant]');
      if (currentInput && currentVariant) {
        currentInput.value = String(currentVariant.id);
        currentInput.dataset.fbtPrice = String(toCents(currentVariant.price));
      }

      const normalizedCurrent = normalizeProductKey(currentProductKey);
      const rendered = [];
      const seen = new Set([normalizedCurrent]);
      for (const item of candidates) {
        const candidateId = normalizeProductKey(item.id);
        if (!item || seen.has(candidateId) || candidateId === normalizedCurrent) continue;
        const variant = (item.variants || []).find((entry) => entry?.available) || item?.variants?.[0];
        if (!variant?.id || !Number(variant.price)) continue;
        seen.add(candidateId);
        rendered.push(`
          <label class="kp-fbt__item">
            <input type="checkbox" checked value="${Number(variant.id)}" data-fbt-variant data-fbt-price="${toCents(variant.price)}">
            <span class="kp-fbt__media">
              ${(item.featured_image || item.images?.[0]) ? `<img src="${escapeHtml(item.featured_image || item.images?.[0])}" alt="${escapeHtml(item.title || 'Kuddy product')}" loading="lazy">` : ''}
            </span>
            <span>
              <small>${escapeHtml(item.badge || item.vendor || 'Kuddy pick')}</small>
              <strong>${escapeHtml(item.title || '')}</strong>
              <b>${formatMoney(variant.price || 0)}</b>
            </span>
          </label>
        `);
        if (rendered.length >= 2) break;
      }

      if (!rendered.length) return false;
      container.innerHTML = `${current.outerHTML}${rendered.join('')}`;
      fbtSection.dataset.fbtSource = 'kuddy-dev';
      const status = fbtSection.querySelector('[data-fbt-status]');
      if (status && payload.source === 'kuddy-dev') {
        status.textContent = 'Based on what customers with similar carts buy.';
      }
      updateFbtTotals();
      return true;
    };

    const enhanceFbt = async () => {
      const used = await updateFbtFromPayload();
      if (!used) return;
      updateFbtTotals();
    };

    const enhanceRoutineFromKuddy = async () => {
      if (!routine || !productId) return false;
      const payload = await hydrateKuddyRecommendations('routine', 8);
      if (!payload?.ok || !Array.isArray(payload.items) || !payload.items.length) {
        // Fall back silently to the server-rendered routine — no data-source status
        // text for shoppers (that slot is for add-to-cart feedback).
        return false;
      }
      const candidates = payload.items;
      const routineStatus = routine.querySelector('[data-routine-status]');

      const current = routine.querySelector('.kp-routine__item--current');
      const container = routine.querySelector('.kp-routine__items');
      if (!container || !current) return false;

      const used = new Set([normalizeProductKey(currentProductKey)]);
      const chosen = [];
      for (const candidate of candidates) {
        const candidateId = normalizeProductKey(candidate.id);
        const variant = routineVariant(candidate);
        if (!candidate?.title || !variant || used.has(candidateId) || candidateId === normalizeProductKey(currentProductKey)) continue;
        used.add(candidateId);
        chosen.push({ item: candidate, badge: candidate.badge || `Smart match ${chosen.length + 2}` });
        if (chosen.length >= 3) break;
      }
      if (!chosen.length) return false;
      container.innerHTML = `${current ? current.outerHTML : ''}${chosen.map(({ item, badge }) => renderRoutineCard(item, badge)).join('')}`;
      routine.dataset.routineSource = 'kuddy-dev';
      if (routineStatus) routineStatus.textContent = 'Based on your profile and cart behavior.';
      return true;
    };

    const enhanceRoutineFromLegacy = async () => {
      if (!routine || !productId) return;
      try {
        const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=10&intent=related`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        const products = (data.products || [])
          .filter((item) => item.available && item.id !== productId && routineVariant(item))
          .map((item, index) => ({ item, index, score: scoreRoutineProduct(item) }))
          .filter((candidate) => candidate.score > 0)
          .sort((a, b) => (b.score - a.score) || (a.index - b.index));
        const chosen = [];
        const usedRoles = new Set();
        for (const candidate of products) {
          const role = routineRole(candidate.item);
          if (usedRoles.has(role) && role !== 'related') continue;
          chosen.push({ item: candidate.item, badge: role === 'related' ? 'Related pick' : `Step ${chosen.length + 2}`, role });
          usedRoles.add(role);
          if (chosen.length >= 3) break;
        }
        if (!chosen.length) return;
        const current = routine.querySelector('.kp-routine__item--current');
        const items = routine.querySelector('.kp-routine__items');
        items.innerHTML = `${current ? current.outerHTML : ''}${chosen.map(({ item, badge }) => renderRoutineCard(item, badge)).join('')}`;
        routine.dataset.routineSource = 'recommendations';
      } catch (_error) {
        // Keep the server-rendered catalog fallback.
      }
    };

    const enhanceRoutine = async () => {
      if (!routine || !productId) return;
      const usedSmart = await enhanceRoutineFromKuddy();
      if (usedSmart) return;
      await enhanceRoutineFromLegacy();
    };

    const hydrateRecommendations = async () => {
      await Promise.allSettled([enhanceFbt(), enhanceRoutine()]);
      updateFbtTotals();
    };

    hydrateRecommendations();
})();
